// 099 运营后台 · 布局：品牌顶栏 + 子导航 + /admin/me 权限闸（D01/D02）
// 权限判定完全在服务端；本层仅做体验拦截（403 → 无权限状态页）。
import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth";
import { ApiError, ops } from "../../lib/api";
import { BrandLogo } from "../../components/BrandLogo";
import "./Dashboard.css";

const NAV = [
  { to: "/dashboard", end: true, label: "总览" },
  { to: "/dashboard/traffic", label: "流量" },
  { to: "/dashboard/users", label: "用户" },
  { to: "/dashboard/projects", label: "项目" },
  { to: "/dashboard/cost", label: "生成与成本" },
  { to: "/dashboard/site", label: "站点健康" },
  { to: "/dashboard/issues", label: "异常与反馈" },
];

export default function DashboardLayout() {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState<"loading" | "ok" | "forbidden" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    ops.me()
      .then(() => setState("ok"))
      .catch((e: unknown) => {
        if (e instanceof ApiError && e.status === 403) {
          setState("forbidden");
          setMessage(e.message);
        } else {
          setState("error");
          setMessage((e as Error).message);
        }
      });
  }, []);

  return (
    <div className="aim-dash">
      <header className="d-top">
        <Link to="/" className="d-wordmark" aria-label="策略咖运营后台">
          <BrandLogo />
          <span className="d-sub">运营后台</span>
        </Link>
        <span className="d-spacer" />
        <span className="d-who"><b>{user?.email}</b>{state === "ok" ? "（授权运营 · 只读）" : ""}</span>
        <button className="d-exit" onClick={() => { void signOut().finally(() => nav("/login")); }}>退出登录</button>
      </header>

      <nav className="d-nav">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => (isActive ? "on" : "")}>
            {n.label}
          </NavLink>
        ))}
      </nav>

      {state === "ok" ? (
        <main className="d-main"><Outlet /></main>
      ) : (
        <main className="d-main">
          <div className="d-statepage">
            {state === "loading" && (<><div className="icon">⏳</div><h2>校验运营权限…</h2></>)}
            {state === "forbidden" && (
              <>
                <div className="icon">🔒</div>
                <h2>无权访问运营后台</h2>
                <p>{message || "当前账号不在授权名单内。运营数据不会加载。"}</p>
                <p><Link to="/projects">返回我的项目</Link></p>
              </>
            )}
            {state === "error" && (
              <>
                <div className="icon">⚠</div>
                <h2>权限校验失败</h2>
                <p>{message}</p>
                <p><button className="d-chip" onClick={() => location.reload()}>重试</button></p>
              </>
            )}
          </div>
        </main>
      )}
    </div>
  );
}
